export const FETCH_BROADCASTDATA_API = "/broadcast/getbroadcast";
export const FETCH_CONTACTS_API = "/contacts/getcontacts";
export const FETCH_COVIDGUIDELINE_API = "/covid/getguidelines";
export const FETCH_COVIDSUMM_API = "/covid/getsummary";
export const SUBSCRIBE_NOTIFICATION = "/notification/subscribe";
